module.exports = __webpack_public_path__ + "img/project-icon.779cef5c.svg";